import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useApi } from 'contexts/ApiContext';

import type api from 'api';

export const useTemplateProject = ({
  accountId,
  projectId,
  options,
}: {
  accountId: string;
  projectId: string;
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof api.getTemplateProject>>,
      unknown,
      Awaited<ReturnType<typeof api.getTemplateProject>>
    >,
    'queryKey' | 'queryFn'
  >;
}) => {
  const { methods } = useApi();

  return useQuery(
    ['template-project', accountId, projectId],
    () => methods.getTemplateProject(accountId, projectId),
    options,
  );
};

export const useTemplateProjects = (
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof api.listTemplateProjects>>,
      unknown,
      Awaited<ReturnType<typeof api.listTemplateProjects>>
    >,
    'queryKey' | 'queryFn'
  >,
) => {
  const { methods } = useApi();

  return useQuery(
    ['template-projects'],
    () => methods.listTemplateProjects(),
    options,
  );
};
